import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { faAnglesLeft, faArrowDownLeftAndArrowUpRightToCenter, faArrowRightFromBracket, faArrowUpRightAndArrowDownLeftFromCenter, faArrowUpRightFromSquare, faGear, faUserCircle } from "@fortawesome/pro-regular-svg-icons";
import { useAuth } from "@qure/qure-auth";
import classNames from "classnames";
import { get } from "lodash";
import Image from "next/image";
import Link from "next/link";
import { useStoreState } from "pullstate";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import constants from "../../utils/constants";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import Store from "../../utils/Store";
import { requestWorklistFilterChange } from "../../utils/worklistFilterNavigation";
import AwesomeIcon from "../AwesomeIcon";
import DropdownMenu from "../common/DropdownMenu";
import ExpandCollapseButton from "../common/ExpandCollapseButton";
import SwitchToggle from "../common/SwitchToggle";
import SearchFilters from "../SearchFilters";
import LCAccessFilters from "./LCAccessFilters";
import SortControl from "./SortControl";
var WorklistHeader = function WorklistHeader(props) {
  var isFullWidthWorklist = props.isFullWidthWorklist,
    setIsFullWidthWorklist = props.setIsFullWidthWorklist,
    labelMappings = props.labelMappings,
    filters = props.filters,
    setFilters = props.setFilters,
    setLastId = props.setLastId,
    setPatientsData = props.setPatientsData,
    savedFilterData = props.savedFilterData,
    setSavedFilterData = props.setSavedFilterData,
    tagsList = props.tagsList,
    patientsCount = props.patientsCount,
    isCountLoading = props.isCountLoading,
    onSearch = props.onSearch,
    showFilters = props.showFilters,
    setShowFilters = props.setShowFilters,
    isMobile = props.isMobile,
    isLCWorklist = props.isLCWorklist,
    onChange = props.onChange,
    patients = props.patients,
    isLoading = props.isLoading,
    _props$isLC = props.isLC,
    isLC = _props$isLC === void 0 ? false : _props$isLC,
    selectedWorkspace = props.selectedWorkspace,
    _props$isBulkActions = props.isBulkActions,
    isBulkActions = _props$isBulkActions === void 0 ? false : _props$isBulkActions,
    sortParams = props.sortParams,
    setSortParams = props.setSortParams,
    savedFilters = props.savedFilters,
    _props$scrollToTop = props.scrollToTop,
    scrollToTop = _props$scrollToTop === void 0 ? function () {} : _props$scrollToTop;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        hasMobileSearch: s.hasMobileSearch
      };
    }),
    hasMobileSearch = _useStoreState.hasMobileSearch;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var currentSearch = get(filters, ["data", "search"], "");
  // Get unread_messages from filters state
  var showUnreadMessages = get(filters, ["unread_messages"], false);
  useEffect(function () {
    if (typeof window !== "undefined") {
      if (isFullWidthWorklist) {
        var _localStorage;
        (_localStorage = localStorage) === null || _localStorage === void 0 || _localStorage.setItem(constants.PERSISTED.isFullWidthWorklist, "true");
      } else {
        var _localStorage2;
        (_localStorage2 = localStorage) === null || _localStorage2 === void 0 || _localStorage2.removeItem(constants.PERSISTED.isFullWidthWorklist);
      }
    }
  }, [isFullWidthWorklist]);
  var toggleFullWidth = function toggleFullWidth() {
    if (!isFullWidthWorklist) {
      trackEvent(MIXPANEL_EVENTS.FULL_WIDTH_WORKLIST_OPENED);
    } else {
      trackEvent(MIXPANEL_EVENTS.FULL_WIDTH_WORKLIST_CLOSED);
    }
    setIsFullWidthWorklist(!isFullWidthWorklist);
  };
  var profileNavigations = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-6 flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faArrowRightFromBracket,
      size: "lg"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start pl-3"
    }, t("logout_key"))),
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.LOGOUT_MODAL_OPENED);
      Store.update(function (s) {
        s.isLogoutOpen = true;
      });
    }
  }];
  var lcFiltersComponent = function lcFiltersComponent() {
    if (!isFullWidthWorklist && savedFilters !== null && savedFilters !== void 0 && savedFilters.length) {
      return /*#__PURE__*/React.createElement(LCAccessFilters, {
        filters: filters,
        setFilters: setFilters,
        setLastId: setLastId,
        setSavedFilterData: setSavedFilterData,
        onChangeSearch: onSearch,
        patientsCount: patientsCount,
        isCountLoading: isCountLoading,
        setDefaulToFirstFilter: isLCWorklist,
        showSearch: isLCWorklist,
        selectedWorkspace: selectedWorkspace,
        showOverflowFiltersOnHover: true,
        setPatientsData: setPatientsData,
        savedFilters: savedFilters
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("relative")
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("hidden sm:flex sm:justify-between text-gray-100 bg-teal-800 dark:bg-gray-800 bold p-4", {
      "bg-white dark:bg-gray-800 border-b-2 dark:border-none border-teal-500 text-gray-800 dark:text-gray-100": isFullWidthWorklist,
      "!p-5 !bg-gray-100 dark:!bg-gray-900 text-gray-800 dark:text-gray-100": isLCWorklist
    })
  }, isLCWorklist ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex p-1 rounded-md border-teal-200 border mr-4 bg-teal-600 cursor-pointer",
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.LC_DASHBOARD_CLICKED);
    }
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/assets/images/qIcon.svg",
    className: "",
    width: "24",
    height: "24",
    alt: "logo"
  })), t("dashboard_key"), /*#__PURE__*/React.createElement("span", {
    className: "ml-6 cursor-pointer",
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.LC_QTRACK_LINK_CLICKED);
      window.location.href = "/";
    }
  }, "qTrack", /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faArrowUpRightFromSquare,
    size: "sm",
    className: "ml-2 text-gray-500 dark:text-gray-200 w-4 h-4"
  })), !window.qminiWidgetAPI && /*#__PURE__*/React.createElement("div", {
    className: "ml-auto"
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    options: profileNavigations,
    menuItemClassName: "z-50 translate-x-[30%]",
    Icon: function Icon(_ref) {
      var open = _ref.open;
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faGear,
        size: "sm",
        className: "text-gray-500 dark:text-gray-200 p-2 w-5 h-5"
      }));
    },
    onOpen: function onOpen() {
      return trackEvent(MIXPANEL_EVENTS.OPEN_SETTINGS);
    }
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: classNames({
      "opacity-0": isFullWidthWorklist
    })
  }, t("worklist_key")), isLC && !isBulkActions && !isLCWorklist && /*#__PURE__*/React.createElement(Link, {
    href: "/worklist",
    shallow: true,
    prefetch: true
  }, /*#__PURE__*/React.createElement("button", {
    title: t("maximize_worklist"),
    className: "flex items-center",
    onClick: function onClick() {
      return trackEvent(MIXPANEL_EVENTS.WORKLIST_MAXIMIZED);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faArrowUpRightAndArrowDownLeftFromCenter,
    className: "text-teal-400 w-4 h-4"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-1 items-center"
  }, isLC && isBulkActions && /*#__PURE__*/React.createElement(Link, {
    href: "/patients",
    prefetch: true
  }, /*#__PURE__*/React.createElement("button", {
    title: t("minimize_worklist"),
    onClick: function onClick() {
      return trackEvent(MIXPANEL_EVENTS.WORKLIST_MINIMIZED);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faArrowDownLeftAndArrowUpRightToCenter,
    className: "text-teal-400 p-2 w-5 h-5"
  }))), !isLCWorklist && !isBulkActions && /*#__PURE__*/React.createElement(ExpandCollapseButton, {
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.WORKLIST_COLLAPSED);
      Store.update(function (s) {
        s.isWorklistCollapsed = true;
      });
    },
    icon: faAnglesLeft,
    title: t("collapse_worklist")
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames("cursor-pointer scale-75 hover:scale-90 justify-self-end", {
      hidden: isBulkActions || isLC || isLCWorklist
    }),
    onClick: toggleFullWidth
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isFullWidthWorklist ? faArrowDownLeftAndArrowUpRightToCenter : faArrowUpRightAndArrowDownLeftFromCenter,
    size: "xl",
    label: isFullWidthWorklist ? "collapseWorklist" : "expandWorklist",
    className: classNames("text-gray-100", {
      "!text-teal-400": isFullWidthWorklist
    })
  }))))), (!isMobile && labelMappings && !isLCWorklist || hasMobileSearch) && /*#__PURE__*/React.createElement(SearchFilters, {
    patients: patients,
    onChange: onChange,
    filters: filters,
    setFilters: setFilters,
    setLastId: setLastId,
    setPatientsData: setPatientsData,
    labelMappings: labelMappings,
    savedFilterData: savedFilterData,
    setSavedFilterData: setSavedFilterData,
    tagsList: tagsList,
    patientsCount: patientsCount,
    isCountLoading: isCountLoading,
    onChangeSearch: onSearch,
    isFullWidthWorklist: isFullWidthWorklist,
    showFilters: showFilters,
    setShowFilters: setShowFilters,
    isLoading: isLoading,
    isLC: isLC,
    selectedWorkspace: selectedWorkspace,
    enableNewFilterLayout: isLC
  }), isLC && isBulkActions && !isMobile && (!isMobile && labelMappings && !isLCWorklist || hasMobileSearch) && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-[35%] left-[375px] flex items-center gap-2 z-10"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-800 dark:text-gray-500 text-md capitalize whitespace-nowrap"
  }, t("label.unread_messages") || "Unread Messages"), /*#__PURE__*/React.createElement(SwitchToggle, {
    value: showUnreadMessages,
    onChange: function onChange(value) {
      trackEvent(MIXPANEL_EVENTS.UNREAD_MESSAGES_FILTER_TOGGLED, {
        value: value
      });
      requestWorklistFilterChange(function () {
        // Update filters state with unread_messages
        setFilters(function (prevFilters) {
          return _objectSpread(_objectSpread({}, prevFilters), {}, {
            unread_messages: value
          });
        });
        // Reset lastId to fetch from the beginning when filter changes
        setLastId("");
      });
    }
  })), lcFiltersComponent(), sortParams && setSortParams && !isMobile && !isBulkActions && isLC && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-4 px-5 border-b border-gray-300 dark:border-gray-700 pb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-800 dark:text-gray-500 text-md capitalize"
  }, t("label.unread_messages") || "Unread Messages"), /*#__PURE__*/React.createElement(SwitchToggle, {
    value: showUnreadMessages,
    onChange: function onChange(value) {
      trackEvent(MIXPANEL_EVENTS.UNREAD_MESSAGES_FILTER_TOGGLED, {
        value: value
      });
      requestWorklistFilterChange(function () {
        // Update filters state with unread_messages
        setFilters(function (prevFilters) {
          var updatedFilter = _objectSpread(_objectSpread({}, prevFilters), {}, {
            unread_messages: value
          });
          localStorage.setItem(constants.PERSISTED.filterObj, JSON.stringify(updatedFilter));
          return updatedFilter;
        });
        // Reset lastId to fetch from the beginning when filter changes
        setLastId("");
      });
    }
  }))), /*#__PURE__*/React.createElement(SortControl, {
    selectedType: sortParams.orderBy,
    onTypeChange: function onTypeChange(type) {
      requestWorklistFilterChange(function () {
        scrollToTop();
        setSortParams(_objectSpread(_objectSpread({}, sortParams), {}, {
          orderBy: type
        }));
        setLastId("");
      });
    },
    sortOrder: sortParams.order,
    onSortChange: function onSortChange(order) {
      requestWorklistFilterChange(function () {
        scrollToTop();
        setSortParams(_objectSpread(_objectSpread({}, sortParams), {}, {
          order: order
        }));
        setLastId("");
      });
    },
    onSortParamsChange: function onSortParamsChange(params) {
      requestWorklistFilterChange(function () {
        scrollToTop();
        setSortParams(params);
        setLastId("");
      });
    },
    sortControlActive: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex space-x-2 items-center mt-3 px-5", {
      hidden: isFullWidthWorklist || isMobile && !currentSearch
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUserCircle,
    size: "sm",
    className: "text-gray-500 dark:text-gray-300"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center text-md text-gray-500 dark:text-gray-300"
  }, isCountLoading ? /*#__PURE__*/React.createElement("div", {
    className: "border-solid border-white border-2 border-r-transparent animate-spin inline-block w-4 h-4 rounded-full text-blue-600 mr-2",
    role: "status"
  }) : patientsCount, /*#__PURE__*/React.createElement("div", {
    className: "ml-2"
  }, filters !== null && filters !== void 0 && filters.isFilterApplied ? t("filter.filtered_patients") : t("patients_key"), " ")))));
};
export default WorklistHeader;